import { useState } from 'react'
import { toast } from 'sonner'
import { useConfirm } from '@/components/common/ConfirmDialog'
import { useDeleteTrack } from '@/features/contract/statuses/hooks'
import type { StatusTrack } from '@/features/contract/statuses/types'
import { TrackFormDialog } from './TrackFormDialog'
import { formatError } from './formatError'

export function TrackListPanel({ tracks, selectedId, onSelect }: {
  tracks: StatusTrack[]
  selectedId: number | null
  onSelect: (id: number) => void
}) {
  const confirm = useConfirm()
  const [creating, setCreating] = useState(false)
  const [editing, setEditing] = useState<StatusTrack | null>(null)
  const del = useDeleteTrack()

  return (
    <aside className="w-72 border-r bg-slate-50 flex flex-col">
      <header className="px-3 py-2 border-b flex items-center justify-between">
        <span className="text-xs uppercase text-slate-500">Tory</span>
        <button onClick={() => setCreating(true)} className="text-xs px-2 py-1 border rounded bg-white hover:bg-slate-100">
          + Dodaj
        </button>
      </header>
      <div className="flex-1 overflow-auto">
        {tracks.length === 0 && <p className="p-3 text-xs text-slate-500">Brak torów.</p>}
        {tracks.map(t => (
          <div
            key={t.id}
            className={[
              'flex items-center justify-between px-3 py-2 border-b cursor-pointer text-sm',
              selectedId === t.id ? 'bg-white border-l-4 border-l-sky-600' : 'hover:bg-white',
            ].join(' ')}
            onClick={() => onSelect(t.id)}
          >
            <div className="min-w-0">
              <div className="truncate">{t.labelPl}</div>
              <div className="text-[10px] font-mono text-slate-500">{t.code} · {t.values.length} wartości</div>
            </div>
            <div className="flex shrink-0">
              <button onClick={e => { e.stopPropagation(); setEditing(t) }} className="text-xs px-1 text-slate-600">✎</button>
              <button
                onClick={async e => {
                  e.stopPropagation()
                  const ok = await confirm({
                    title: `Usunąć tor ${t.code}?`,
                    description: 'Wartości zostaną skasowane (kaskada). Historia wpisów zostaje.',
                    confirmLabel: 'Usuń',
                    variant: 'destructive',
                  })
                  if (ok) del.mutate(t.id, { onError: e => toast.error(formatError(e)) })
                }}
                className="text-xs px-1 text-red-600"
              >×</button>
            </div>
          </div>
        ))}
      </div>
      {(creating || editing) && (
        <TrackFormDialog editing={editing} onClose={() => { setCreating(false); setEditing(null) }} />
      )}
    </aside>
  )
}
